export const firebaseEnvPrefix =
  process.env.REACT_APP_NODE_ENV === 'staging'
    ? 'new_staging'
    : process.env.REACT_APP_NODE_ENV;
